import { render, staticRenderFns } from "./SawList.vue?vue&type=template&id=18c1a7d0"
import script from "./SawList.vue?vue&type=script&lang=js"
export * from "./SawList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports